import { useFeatureGate } from '@statsig/expo-bindings';
import { router } from 'expo-router';
import {
    BodyMediumRegular,
    Button,
    ButtonVariant,
    GRADIENT_COLOR_BOTTOM,
    GRADIENT_COLOR_TOP,
    H6Emphasized,
    YStack,
} from 'smoothie';
import { LinearGradient } from 'tamagui/linear-gradient';

import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import { SIDEBAR_CONTENT_MAX_WIDTH } from '../../../common/utils/homeUtils';
import { FeatureFlags } from '../../../feature-flags/FeatureFlags';
import useGetFreeToSpendTransactionsCount from '../../hooks/useGetFreeToSpendTransactionsCount';

export const SproutCtaCard = () => {
    const { value: enableSproutChat } = useFeatureGate(
        FeatureFlags.ENABLE_SPROUT_CHAT,
    );
    const { value: freeToSpendWidgetEnabled } = useFeatureGate(
        FeatureFlags.ENABLE_FREE_TO_SPEND_WIDGET,
    );
    const user = useAuthedUser();
    const spendWidgetVisible =
        freeToSpendWidgetEnabled && !!user.memberJourneyLog?.completedMoneyMap;

    const { data: spendTransactionCount } =
        useGetFreeToSpendTransactionsCount(spendWidgetVisible);

    const hasSpendTransactions = (spendTransactionCount?.count ?? 0) > 0;

    // Members need to be gated for Fruitful AI, have the FTS widget (feature gated + completed money map), and have at
    // least 1 spend transaction in the last 1 year.
    if (!enableSproutChat || !spendWidgetVisible || !hasSpendTransactions) {
        return null;
    }

    const handlePress = () => {
        router.push('/chat');
    };

    return (
        <YStack
            width="100%"
            borderRadius={24}
            overflow="hidden"
            position="relative"
            $sm={{
                maxWidth: SIDEBAR_CONTENT_MAX_WIDTH,
                alignSelf: 'center',
            }}
        >
            <YStack position="absolute" top={0} left={0} right={0} bottom={0}>
                <LinearGradient
                    colors={[GRADIENT_COLOR_TOP, GRADIENT_COLOR_BOTTOM]}
                    start={[0, 0]}
                    end={[0, 1]}
                    width="100%"
                    height="100%"
                />
            </YStack>
            <YStack padding={24} gap={24}>
                <YStack gap={4}>
                    <H6Emphasized color="$black">
                        Money that finally makes sense.
                    </H6Emphasized>
                    <BodyMediumRegular color="$black">
                        Fruitful AI helps you understand spending habits, where
                        your money goes, and how your system is working.
                    </BodyMediumRegular>
                </YStack>
                <Button
                    text="Try Fruitful AI"
                    variant={ButtonVariant.PRIMARY}
                    width="full"
                    onPress={handlePress}
                />
            </YStack>
        </YStack>
    );
};
